import mapKnownValues from "@/utils/mapKnownValues";

export type StationTransactionIntervalAPIResponse = {
  intervalId: string;
  sessionId: string;
  intervalStartDateTime: string; // datetime
  intervalEndDateTime: string; // datetime
  intervalKwh: 0;
  intervalMaxDemandKW: 0;
  intervalAverageDemandKW: 0;
  drEventCalled: string;
  drEventParticipated: string;
  jsonData: Record<string, string>;
};

export default class StationTransactionInterval {
  intervalId = "";
  sessionId = "";
  jsonData?: Record<string, string> = {};
  intervalStartDateTime = new Date();
  intervalEndDateTime = new Date();
  intervalKwh = -1;
  intervalMaxDemandKW = -1;
  intervalAverageDemandKW = -1;
  drEventCalled = "";
  drEventParticipated = "";

  constructor(params: Partial<StationTransactionInterval> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: StationTransactionIntervalAPIResponse) {
    return new StationTransactionInterval({
      ...response,
      intervalStartDateTime: new Date(response.intervalStartDateTime),
      intervalEndDateTime: new Date(response.intervalEndDateTime)
    });
  }
}
